setTimeout(() => {
  const webChat = document.createElement("script");
  webChat.defer = true;

  webChat.src = `${process.env.PUBLIC_URL}/WebChatClient.js`;
  document.body.appendChild(webChat);
}, 3000);

export {};
